<template lang="pug">
  shListData(title="Órdenes Zimple" resolver="ordersDropshipping" keyData="order" component="shOrderDropshipping")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Orders',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/orderDropshipping/OrdersDropshipping.vue